import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useCategory(data = {}) {
  const { enabled = false, config = {}, queryKey = ['podcast-category'] } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const getCategory = () => privateFetch.get('/v1/admin/podcast/supporting/categories', { params });

  return useQuery(queryKey, getCategory, {
    enabled,
    keepPreviousData: true,
  });
}

export default useCategory;
